import { ConnectionStatus } from '../types';

const TIME_CONSTANTS = {
  SECOND: 1000,
  MINUTE: 60 * 1000,
  HOUR: 60 * 60 * 1000,
} as const;

const UPDATE_THRESHOLDS = {
  RECENT: 60,
  MINUTES: 60 * 60,
} as const;

export function formatLastUpdate(
  lastDataUpdate: Date | null | undefined,
  alias: (text: string) => string,
): string {
  if (!lastDataUpdate) {
    return alias('Never');
  }

  const now = Date.now();
  const updateTime = lastDataUpdate.getTime();
  const diffSeconds = Math.floor((now - updateTime) / TIME_CONSTANTS.SECOND);

  if (diffSeconds < UPDATE_THRESHOLDS.RECENT) {
    return alias('Updated less than a minute ago');
  }

  const minutes = Math.floor(diffSeconds / 60);
  if (minutes < 60) {
    return minutes === 1
      ? alias('1 minute ago')
      : alias('{count} minutes ago').replace('{count}', minutes.toString());
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return hours === 1
      ? alias('1 hour ago')
      : alias('{count} hours ago').replace('{count}', hours.toString());
  }

  const days = Math.floor(hours / 24);
  return days === 1
    ? alias('1 day ago')
    : alias('{count} days ago').replace('{count}', days.toString());
}

export function getStatusLabel(
  connectionStatus: ConnectionStatus,
  topicCount = 0,
  alias: (text: string) => string,
): string {
  const labels: Record<ConnectionStatus, string> = {
    connected:
      topicCount > 0
        ? alias('Live Data ({count} topics)').replace(
            '{count}',
            topicCount.toString(),
          )
        : alias('Live Data'),
    disconnected: alias('Offline'),
    reconnecting: alias('Reconnecting...'),
  };

  return labels[connectionStatus];
}
